'use client';

import { useEffect, useState } from 'react';

import { prefersReducedMotion, readPrefsCookie } from './prefs';

/**
 * Motion is decided after hydration so the server and first client render agree.
 * OS reduced-motion and the boarding preference both make gated actions settle instantly.
 */
export function useGatedActionMotion() {
  const [instant, setInstant] = useState(false);

  useEffect(() => {
    setInstant(prefersReducedMotion() || readPrefsCookie().motion === 'off');
  }, []);

  return instant;
}
